import { Box, Checkbox, styled, useTheme, Typography } from '@mui/material';
import ButtonCircle from '../ButtonCircle';
import GetSocialMediaIcon from '../GetSocialMediaIcon';
import { TEcommerce } from '../EcommerceObjectPreview';

const Container = styled(Box)(
  () => `
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 6px 9px 6px 9px;
    border-radius:18px;
    background: #FBFBFB;
    border: 1px solid #E8E9EA;
    box-sizing: border-box;
  `
);

const CustomCheckbox = styled(Checkbox)<{ activeBgColor: string }>(
  ({ theme, activeBgColor }) => `
    padding: ${theme.spacing(1)} 0px ${theme.spacing(1)} 2px;
    width: ${theme.spacing(5)};
    height: ${theme.spacing(3)};
    border-radius: ${theme.spacing(1.43)};
    padding: 0;
    margin: 0;

    &.Mui-checked {
      background-color: ${activeBgColor};
      color: white;
    }

    &:not(.Mui-checked) {
      background-color: ${theme.palette.grey[100]};
      border: 1px solid ${theme.palette.grey[300]};
      color: ${theme.palette.grey[600]};
    }

    &:hover {
      background-color: ${activeBgColor};
      opacity: 0.8;
    }

    &:not(.Mui-checked):hover {
      background-color: ${theme.palette.grey[200]};
      opacity: 1;
    }

    .MuiSvgIcon-root {
      font-size: 16px;
    }
  `
);

interface Props {
  selectedPlatforms: TEcommerce[];
  handleChange: (platform: TEcommerce) => void;
  handleClickAll: () => void;
}

export const ECOMMERCE_LIST: TEcommerce[] = [
  'lazada',
  'tokopedia',
  'shopee',
  'blibli'
  // 'tiktokshop',
  // 'olx'
];

const FilterObjectByPlatformEcommerce = ({
  selectedPlatforms,
  handleChange,
  handleClickAll
}: Props) => {
  const theme = useTheme();
  const isSelected = (platform: TEcommerce) =>
    selectedPlatforms.includes(platform);

  const getEcommerceBgColor = (platform: TEcommerce) => {
    switch (platform) {
      case 'blibli':
        return '#56B6E9';
      case 'lazada':
        return '#070286';
      // case 'olx':
      //   return '#3A77FF';
      case 'shopee':
        return '#EE4D2D';
      // case 'tiktokshop':
      //   return '#051C26';
      case 'tokopedia':
        return '#42B549';
      default:
        return '#E0F6FF';
    }
  };

  return (
    <Container>
      <ButtonCircle
        onClick={handleClickAll}
        sx={{
          marginRight: theme.spacing(2),
          background: '#E0F6FF'
        }}
      >
        <Typography
          sx={{ fontSize: '14px', color: '#009FE3', fontWeight: 600 }}
        >
          All
        </Typography>
      </ButtonCircle>
      {ECOMMERCE_LIST.map((platform) => (
        <CustomCheckbox
          key={platform}
          activeBgColor={getEcommerceBgColor(platform)}
          checked={isSelected(platform)}
          onChange={() => handleChange(platform)}
          sx={{ marginRight: theme.spacing(2) }}
          icon={
            <GetSocialMediaIcon socialMedia={platform} sx={{ fontSize: 16 }} />
          }
          checkedIcon={
            <GetSocialMediaIcon
              socialMedia={platform}
              sx={{ color: 'white', fontSize: 16 }}
            />
          }
        />
      ))}
    </Container>
  );
};

export default FilterObjectByPlatformEcommerce;
